import 'jquery-ui/ui/widgets/sortable';

/*
THIS COMPONENT INCLUDING IN ALL ADMIN PAGES
 ---------------------------------------------*/
/*  VARIANTS TABLE
 -----------------------------*/
let VariantsTable = {

    isClearRow(element) {
        return element.find('input').filter(function () {
            return this.value.length > 0
        }).length > 0;
    },
    ajaxRemoveVariant(variantButton) {
        let variantId = $(variantButton).data('id');
        if (variantId) {
            $('#discount_percent_' + variantId).remove();
            $.ajax({
                url: '/catalog/variants/' + variantId,
                type: 'POST',
                data: {
                    _method: 'DELETE',
                },
                success: function (result) {

                }
            });
        }
    },
    isLastRow() {
        return $('.b-admin-products-variants__table tbody').find('tr').length < 2;
    },

    getVariantTr(element) {
        return element.parents('tr.b-admin-products-variants__row').first();
    },
    isConfirmRemove() {
        return confirm("Удалить упаковку?");
    },
    loadNewVariantView(element) {
        let type = $(element).data('type');
        $.get('/catalog/variants/' + type + '/add_new_form_row', function (data) {
            $('.b-admin-products-variants__table').append(data);
        });
    },
    removeVariant(element) {
        // при удалении варианта проверяется не последняя ли строка
        // если последняя то просто очистим поля не удаляя инпутов. В других случаях удаляем строки с инпутами
        let variantTr = this.getVariantTr(element);
        let isClearRow = this.isClearRow(variantTr);

        this.ajaxRemoveVariant(element);

        if (this.isLastRow()) {
            return variantTr.find('input').val('');
        }

        if (isClearRow == false) {
            return variantTr.remove();
        }

        if (this.isConfirmRemove()) {
            variantTr.remove();
        }
    },
    initSortable($containerVariants) {
        $containerVariants.sortable();
    },
    appendSortingInput(elem, sortingIndex) {
        let fieldIndex = elem.data('index');
        if (typeof fieldIndex === 'undefined') {
            fieldIndex = '';
        }
        elem.append(
            $('<input/>')
                .attr('type', 'hidden')
                .attr('name', 'variants[sorting][' + fieldIndex + ']')
                .val(sortingIndex + 1)
        );
    },
    init() {

        let self = this;
        let $containerVariants = $('#variants_container');

        $("#product_variants_add_more").on('click', function (element) {
            element.preventDefault();
            self.loadNewVariantView(element.target);
        });

        $("body").on("click", ".b-remove-pack__button", function (element) {
            element.preventDefault();
            self.removeVariant($(this));
        });

        self.initSortable($containerVariants);
    }
};

export default VariantsTable;





